import React from 'react'
import styles from './Link.module.scss'
import cx from 'classnames'

type LinkProps = {
    url: string
    children: string | JSX.Element
    classes?: string
    target?: string
}

const Link: React.FC<LinkProps> = ({ url, children, classes, target }) => {
    return (
        <a
            href={url}
            className={cx(styles['zr-link'], classes)}
            target={target}
        >
            {children}
        </a>
    )
}

export default Link
